import React, { useEffect, useState } from "react";
import { collection, doc, onSnapshot, serverTimestamp, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { getAuth } from "firebase/auth";

// presenceKey: e.g. "missions", "map_locations"
// entityId:    e.g. missionId, locId
export default function PresenceBadge({ presenceKey, entityId }) {
  const auth = getAuth();
  const user = auth.currentUser;
  const [count, setCount] = useState(1);

  // Listen for peers in this entity
  useEffect(() => {
    if (!presenceKey || !entityId) return;
    const peersCol = collection(db, "presence", presenceKey, "entities", entityId, "peers");
    const unsub = onSnapshot(peersCol, (snap) => setCount(snap.size || 1));
    return () => unsub();
  }, [presenceKey, entityId]);

  // Advertise my presence
  useEffect(() => {
    if (!user || !presenceKey || !entityId) return;
    const ref = doc(db, "presence", presenceKey, "entities", entityId, "peers", user.uid);

    const ping = async () => setDoc(ref, { lastSeen: serverTimestamp() }, { merge: true });
    const leave = async () => { try { await deleteDoc(ref); } catch {} };

    ping();
    const id = setInterval(ping, 25000);       // keep-alive
    window.addEventListener("beforeunload", leave);
    return () => { clearInterval(id); leave(); window.removeEventListener("beforeunload", leave); };
  }, [presenceKey, entityId, user?.uid]);

  return <span className="msn-chip" title="Users viewing now">👥 {count}</span>;
}
